<template>
  <div>
    <FilterCard :applied-filter-count="appliedFilterCount">

      <b-row>
        <b-col
          cols="6"
          md="3"
        >
          <b-form-group
            label="Flag Name"
            label-for="Flag"
          >
            <v-select
              v-model="selectedFlagFilters"
              :options="flagOptions"
              :reduce="option => option.name"
              label="name"
              placeholder="Select Flag"
              multiple
              deselect-from-dropdown
            >
              <template
                v-slot:option="option"
              >
                {{ option.name }}
              </template>
            </v-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-1">
        <b-col>
          <filter-buttons
            :filter-data="filters"
            :apply-filters="applyFilters"
            :clear-filters="clearFilters"
          />
        </b-col>
      </b-row>
    </FilterCard>
    <!-- table -->
    <b-card
      no-body
    >
      <div
        class="m-2"
      >
        <b-row>
          <b-col
            cols="12"
            md="8"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1 ml-1"
          >
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              class="custom-button-color add-new-button"
              @click="onClickOpenAddNewDetailModal"
            >
              <feather-icon icon="PlusIcon" />
              Add New
            </b-button>
          </b-col>
          <b-col
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <ReportTableButtons
              :items="items"
              :json_fieldz="json_fields"
              :name="`Order Flag - Page ${page}.xls`"
              :bulkname="`Order flag.xls`"
              :fetch="getFlagListNoPagination"
              @refresh="onClickRefresh"
            />
          </b-col>
        </b-row>
      </div>
      <b-overlay
        id="overlay-background"
        variant="light"
        opacity="0.30"
        blur="10px"
        rounded="sm"
      >
        <b-table
          :per-page="perPage"
          :fields="fields"
          :items="items"
          hover
          responsive
          striped
          show-empty
          sticky-header="100vh"
          class="hide-vertical-scroll"
          @sort-changed="sortChanged"
        >
          <template #empty>
            <TableDataFetching
              :rows="items"
              :data-loading="dataLoading"
            />
          </template>
          <template #head()="{ field }">
            <div
              class="sortable-header"
            >
              <span class="header-text">{{ field.label }}</span>
              <feather-icon
                v-if="field.sortable"
                :icon="sort === field.key
                  ? 'ArrowUpIcon'
                  : 'ArrowDownIcon'"
                size="14"
              />
            </div>
          </template>
          <template #cell(name)="data">
            <div class="d-flex align-items-start">
              {{ data.item.name }}
            </div>
          </template>
          <template #cell(icon)="data">
            <div class="width-150">
              <div v-if="data.item.type === 'flag_1'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-info"
                    size="32"
                  >
                    <feather-icon
                      icon="TruckIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.type === 'flag_2'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-danger"
                    size="32"
                  >
                    <feather-icon
                      icon="AlertOctagonIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.type === 'flag_3'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-primary"
                    size="32"
                  >
                    <feather-icon
                      icon="RepeatIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.type === 'flag_4'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-dark"
                    size="32"
                  >
                    <feather-icon
                      icon="ArrowLeftIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.type === 'flag_5'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-success"
                    size="32"
                  >
                    <feather-icon
                      icon="ClockIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.type === 'flag_6'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-warning"
                    size="32"
                  >
                    <feather-icon
                      icon="UmbrellaIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.type === 'flag_7'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-danger"
                    size="32"
                  >
                    <feather-icon
                      icon="HomeIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.type === 'flag_8'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-info"
                    size="32"
                  >
                    <feather-icon
                      icon="RotateCwIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.type === 'flag_9'">
                <span class="mr-1">
                  <b-avatar
                    variant="light-primary"
                    size="32"
                  >
                    <feather-icon
                      icon="CloudIcon"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
              <div v-if="data.item.is_system === false">
                <span class="mr-1">
                  <b-avatar
                    :variant="getCustomVariant(data.item)"
                    size="32"
                  >
                    <feather-icon
                      :icon="getCustomIcon(data.item)"
                      size="20"
                    />
                  </b-avatar>
                </span>
              </div>
            </div>
          </template>
          <template #cell(is_system)="data">
            <div v-if="data.value === true">
              <b-badge variant="light-success">
                Yes
              </b-badge>
            </div>
            <div v-if="data.value === false">
              <b-badge variant="light-warning">
                No
              </b-badge>
            </div>
          </template>
          <template #cell(is_active)="data">
            <div v-if="data.value === true">
              <b-badge variant="light-success">
                Active
              </b-badge>
            </div>
            <div v-if="data.value === false">
              <b-badge variant="light-danger">
                Inactive
              </b-badge>
            </div>
          </template>
          <template #cell(created_at)="data">
            <div class="d-flex align-items-start">
              {{ __dateTimeFormatter(data.item.created_at) }}
            </div>
          </template>
          <template #cell(updated_at)="data">
            <div class="d-flex align-items-start">
              {{ __dateTimeFormatter(data.item.updated_at) }}
            </div>
          </template>
          <template #cell(action)="data">
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="12"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item
                v-if="data.item.type !== 'flag_9'"
                @click="onClickViewOrder(data.item.id)"
              >
                <feather-icon icon="EyeIcon" />
                Manage Setting
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row cols="12">
            <!-- Pagination -->
            <b-col
              md="3"
              class="d-flex align-items-center justify-content-sm-start"
            >
              <label class="width-75">Per page</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="pageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block"
              />
            </b-col>
            <!-- Pagination -->
            <b-col
              md="9"
              class="d-flex align-items-center justify-content-sm-end"
            >
              <span class="text-muted mr-1">Showing {{ meta.from }} to {{ meta.to }} of {{ meta.total }} entries</span>
              <b-pagination
                v-model="page"
                :total-rows="(meta.total)? meta.total : 0"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-overlay>
    </b-card>
    <manage-flag ref="ManageFlag" />
    <add-new-detail-modal ref="add_new_detail_modal" />
  </div>
</template>

<script>
import {
  BTable,
  BDropdown,
  BRow,
  BCol,
  BCard,
  BOverlay,
  BFormGroup,
  BDropdownItem,
  BPagination,
  VBTooltip,
  VBModal,
  BAvatar,
  BButton,
  BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import Filter from '@core/mixins/filter'
import SuccessMessage from '@core/mixins/SuccessMessage'
import store from '@/store/index'
import ManageFlag from '@/components/setting/ManageFlag.vue'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import FilterButtons from '@/components/Filter/FilterButtons.vue'
import AddNewDetailModal from '@/components/setting/AddNewFlagModal.vue'
import tableMixin from '@core/mixins/tableMixin'
import FilterCard from '@/components/FilterCard/FilterCard.vue'

const flagRepository = RepositoryFactory.get('flag')
const ResourceRepository = RepositoryFactory.get('resource')

export default {
  components: {
    ManageFlag,
    BTable,
    BDropdown,
    BRow,
    BCol,
    BCard,
    BOverlay,
    BFormGroup,
    BDropdownItem,
    vSelect,
    BPagination,
    FilterCard,
    FilterButtons,
    BAvatar,
    BButton,
    AddNewDetailModal,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
    Ripple,
  },
  mixins: [Filter, SuccessMessage, ErrorMessage, tableMixin],
  props: {
    type: {
      type: String,
      default: 'Order',
    },
  },
  data() {
    return {
      filters: [],
      total: 0,
      meta: {},
      dataLoading: false,
      selectedFlagFilters: [],
      perPage: 20,
      pageOptions: [10, 20, 50],
      page: 1,
      items: [],
      pageLength: 20,
      downloadReportName: 'Order-Flag',
      filter: null,
      filterOn: [],
      dir: false,
      sort: '',
      flagOptions: [],
      fields: [
        {
          key: 'name',
          label: 'Flag Name',
          thClass: 'text-left',
          tdClass: 'text-left',
          thStyle: { width: '220px' },
        },
        {
          key: 'icon',
          label: 'Flag Icon',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '175px' },
        },
        {
          key: 'is_system',
          label: 'Is System',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'is_active',
          label: 'Status',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'created_at',
          label: 'Created AT',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'updated_at',
          label: 'Updated AT',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left',
        },
        {
          key: 'action',
          label: 'Action',
          thClass: 'text-left',
          tdClass: 'text-left',
        },
      ],
      json_fields: {
        'Flag Name': {
          field: 'name',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => `"${value}"`,
        },
        'Created Date': {
          field: 'created_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
        'Updated Date': {
          field: 'updated_at',
          // eslint-disable-next-line no-underscore-dangle
          callback: value => this.__dateTimeFormatter(value),
        },
      },
      customIconPool: [
        { icon: 'StarIcon', variant: 'light-primary' },
        { icon: 'TagIcon', variant: 'light-success' },
        { icon: 'GiftIcon', variant: 'light-info' },
        { icon: 'ZapIcon', variant: 'light-warning' },
        { icon: 'BookmarkIcon', variant: 'light-dark' },
        { icon: 'CompassIcon', variant: 'light-danger' },
      ],
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  watch: {
    options: {
      handler() {
        this.getFlagList()
      },
    },
    deep: true,
    page() {
      this.getFlagList()
    },
    perPage() {
      this.getFlagList()
    },
    selectedFlagFilters: {
      async handler(val) {
        let keyList = ''
        val.forEach(key => {
          keyList += `${key},`
        })
        this.filters = {
          name: keyList,
        }
      },
      deep: true,
    },
  },
  async mounted() {
    if (!this.$can('flag-show')) {
      this.fields = this.fields.filter(field => field.key !== 'action')
    }
    await this.readOrderFlags()
    await this.getFlagList()
    this.updateFilterCount()
  },
  methods: {
    async readOrderFlags() {
      this.flagOptions = localStorage.getItem('flag_list') ? JSON.parse(localStorage.getItem('flag_list')) : (await ResourceRepository.getFlagList()).data.data
      if (!localStorage.getItem('flag_list')) localStorage.setItem('flag_list', JSON.stringify(this.flagOptions))
    },
    onClickViewOrder(id) {
      this.$refs.ManageFlag.openModal(id)
    },
    async getFlagList() {
      this.dataLoading = true
      this.items = []
      try {
        // eslint-disable-next-line no-underscore-dangle
        const { data } = (await flagRepository.getFlagList(this.filterQuery, this.page, this.perPage))
        this.items = data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.dataLoading = false
    },
    async getFlagListNoPagination() {
      try {
        // eslint-disable-next-line no-underscore-dangle
        const { data } = (await flagRepository.getFlagListNoPagination(this.filterQuery))
        return data.data
      } catch (e) {
        this.convertAndNotifyError(e)
        return []
      }
    },
    onClickRefresh() {
      this.getFlagList()
    },
    handleChangePage(page) {
      this.page = page
      this.getFlagList()
    },
    applyFilters() {
      this.getFlagList()
      this.updateFilterCount()
    },
    clearFilters() {
      this.selectedFlagFilters = ''
      this.filters = {}
      this.$nextTick(() => {
        this.getFlagList()
      })
      this.updateFilterCount()
    },
    onClickOpenAddNewDetailModal() {
      this.$refs.add_new_detail_modal.openModal()
    },
    getCustomIcon(item) {
      const pool = this.customIconPool
      if (!pool || pool.length === 0) return ''
      let index = 0
      if (item && item.id != null) {
        index = Number(item.id) % pool.length
      } else if (item && item.name) {
        index = item.name.charCodeAt(0) % pool.length
      }
      return pool[index].icon
    },
    getCustomVariant(item) {
      const pool = this.customIconPool
      if (!pool || pool.length === 0) return ''
      let index = 0
      if (item && item.id != null) {
        index = Number(item.id) % pool.length
      } else if (item && item.name) {
        index = item.name.charCodeAt(0) % pool.length
      }
      return pool[index].variant
    },
  },
}
</script>

<style lang="scss">
@import '../@core/scss/vue/libs/vue-select.scss';
.per-page-selector {
  width: 125px;
}
@media (min-width: 768px) and (max-width: 1023px) {
  .per-page-selector {
    width: 200px; /* Shrinks in tablet view */
  }
}
</style>
